import { ReactElement, useMemo } from 'react'
import { Grid } from '@mui/material'
import { Form, TextField, UnitConvertedField } from '@ui/forms'
import { connectionSchema, makeConnectionSchema } from './schema'

interface Props {
  id: string
  defaultValues: Connection
  onSubmit: (values: Connection) => void
  /** Short names of the other connectors of the library / project */
  takenShortNames: string[]
}

const ConnectionForm = ({ defaultValues, id, onSubmit, takenShortNames }: Props): ReactElement => {
  const validationSchema = useMemo(() => makeConnectionSchema(takenShortNames), [takenShortNames])

  return (
    <Form
      id={id}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      defaultValues={{
        ...connectionSchema.getDefault(),
        ...defaultValues,
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={8}>
          <TextField
            label="Name"
            name="name"
            placeholder="Zugverbindung 1"
            data-cy="connection-name"
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            label="Kurzbezeichnung"
            name="short_name"
            placeholder="ZA 01"
            data-cy="connection-short-name"
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Kommentar im Export"
            name="export_comment"
            data-cy="connection-comment"
          />
        </Grid>

        <Grid item xs={6}>
          <UnitConvertedField
            label={
              <>
                R<sub>d</sub> Erdbeben (sehr kurz)
              </>
            }
            name="r_d_earthquake"
            data-cy="r_d_earthquake"
          />
        </Grid>
        <Grid item xs={6}>
          <UnitConvertedField
            label={
              <>
                R<sub>d</sub> Wind (kurz/sehr kurz)
              </>
            }
            name="r_d_wind"
            data-cy="r_d_wind"
          />
        </Grid>
      </Grid>
    </Form>
  )
}

export default ConnectionForm
